const specificProviders = [
    'yahoo',
    'icloud',
    'google',
    'outlook',
    'windowslive'
]

export default {

    isSpecificProvider: function (provider) {
        return specificProviders.includes(provider ? provider.toLowerCase() : '')
    }

}
